import React, { useState } from 'react'
import {
  Note,
  SkillList,
  SkillsWrapper,
  StyledStarFilled,
  StyledStarOutlined,
  StyledTag,
} from './Styles'
import Label from 'components/Form/Label'
import DropDown from 'components/Form/DropDown'

const Skills = ({
  skillList,
  handleSearch,
  skillLoading,
  getskillList,
  disabled,
  selectedSkills,
  setSelectedSkills,
  mandatorySkillsIds,
  setMandatorySkillsIds,
  setPreviewData,
  previewData,
  eligibleCandidatesMetrics,
  roleFormData
}) => {
  const [searchValue, setSearchValue] = useState('')

  const handleRemoveSkill = skill => {
    setSelectedSkills((selectedSkills || []).filter(s => s?.id !== skill?.id));
    setMandatorySkillsIds(prev => prev.filter(id => id !== skill?.id));
    const updatedSkills = (selectedSkills || []).filter(s => s?.id !== skill?.id);
    const jobRoleSkills = updatedSkills.map(skill => ({ 
      ...skill, 
      name: skill.skillName,
      skillId: skill.skillId || skill.id
    }));
    setPreviewData({
      ...previewData,
      jobRoleSkills,
    });
  }

  const handleMandatory = skill => {
    setSelectedSkills(prevSkills => {
      const updatedSkills = prevSkills.map(s =>
        s.id === skill.id ? { ...s, isMandatory: !s.isMandatory } : s
      );
      const jobRoleSkills = updatedSkills.map(skill => ({ 
        ...skill, 
        name: skill.skillName,
        skillId: skill.skillId || skill.id
      }));
      setPreviewData({
        ...previewData,
        jobRoleSkills,
      });

      let data = {
        ...roleFormData,
        jobRoleSkills: jobRoleSkills
      }
      eligibleCandidatesMetrics(data)
      return updatedSkills;
    });
    if (skill?.isMandatory) {
      if (!mandatorySkillsIds?.includes(skill?.id)) {
        mandatorySkillsIds?.filter(item => item.id != skill.id)
        setMandatorySkillsIds(mandatorySkillsIds)
      }
    } else {
      if (mandatorySkillsIds?.includes(skill?.id)) {
        mandatorySkillsIds?.filter(item => item.id != skill.id)
        setMandatorySkillsIds(mandatorySkillsIds)
      }
    }

 
  }
  //const debouncedSearch = useMemo(() => debounce(getskillList, 300), [getskillList]);

  const handleSkillSearch = value => {
    setSearchValue(value)
    //debouncedSearch(value);
    handleSearch(value, 'skill')
  }

  const handleSkillsChange = (selectedValues, selectedObjects) => {
    setSelectedSkills(prevSkills => {
      const updatedSkills = selectedObjects?.map(obj => {
        // Find if this skill was already selected before
        const prev = prevSkills?.find(
          s => s?.id === obj?.id || s?.value === obj?.value
        );
        // Ensure skillId is properly set
        const skillId = obj?.id || obj?.skillId || obj?.value || obj?.skillName;
        // Set mandatory true if id is in mandatorySkillsIds, else preserve previous or default to false
        return {
          ...obj,
          id: skillId,
          skillId: skillId,
          skillName: obj?.skillName || obj?.name || obj?.label,
          isMandatory: mandatorySkillsIds?.includes(skillId)
            ? true
            : prev?.isMandatory || false,
        };
      });
      const jobRoleSkills = updatedSkills.map(skill => ({ 
        ...skill, 
        name: skill.skillName,
        skillId: skill.skillId || skill.id
      }));
      setPreviewData({
        ...previewData,
        jobRoleSkills,
      });
      return updatedSkills;
    });
  }

  return (
    <SkillsWrapper>
      <Label>Skills</Label>
      <Note>Click on the star to make the skill mandatory.</Note>
      <DropDown
        options={skillList}
        placeholder="Select Skill"
        mode="multiple"
        nameParam="skillName"
        valueParam="id"
        name="elgibilty.skills"
        value={selectedSkills.map(skill => skill.id)}
        onChange={handleSkillsChange}
        showSearch
        onSearch={handleSkillSearch}
        loading={skillLoading}
        isFilterOption={false}
        disabled={disabled}
        //isCombined
      />
      <SkillList>
        {selectedSkills.map(skill => (
          <StyledTag
            key={skill.id || skill.skillName}
            onClose={() => handleRemoveSkill(skill)}
            closable
            disabled={disabled}
          >
            {skill.skillName}
            {skill.isMandatory ? (
              <StyledStarFilled
                onClick={() => handleMandatory(skill)}
                checked={skill.isMandatory}
              />
            ) : (
              <StyledStarOutlined
                onClick={() => handleMandatory(skill)}
                checked={skill.isMandatory}
              />
            )}
          </StyledTag>
        ))}
      </SkillList>
    </SkillsWrapper>
  )
}
export default Skills
